"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var commentUtils_1 = require("../utils/commentUtils");
var baseViewModel_1 = require("./base/baseViewModel");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        _super.call(this, options);
        app.setBlockPullToRefresh(true);
        commentUtils_1.default.init(options.lastViewTime);
    }
    return ViewModel;
}(baseViewModel_1.default));
;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=androidCollectionComments.js.map